import { Grid, Typography } from '@mui/material'
import InputTextBox from '../../../../constants/InputTextBox'
import Container from '../../../../constants/Container'
import useFetchData from '../../../../helpers/useFetch';
import AppURL from '../../../../constants/AppURL';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { GeneralLedgerOptions, ParticularOptions, SearchMemberListOptions, SubLedgerOptions } from '../../../../constants/Options';
import { useFormik } from 'formik';
import useFetchSubData from '../../../../helpers/useSubFetch';
import { useState } from 'react';
import { handleChangeDate } from '../../../../helpers/handleChange';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SecHeading from '../../../../constants/SecHeading';
import { fetchDataFromApi } from '../../../../helpers/api';
interface LedgerFormProps {
    setOnLedgerList: any;
}
const LedgerFormView: React.FC<LedgerFormProps> = ({ setOnLedgerList }) => {
    const { data, loading, error } = useFetchData(`${AppURL.AccountURL}account/general/ledger/options/list/view/`);
    const { current_fiscal_year_list } = useSelector((state: RootState) => state.software);
    const date_now = NepNowDateFormat();
    const initialValues = {
        from_date_n: current_fiscal_year_list?.fiscal_year?.from_date_n || "",
        to_date_n: date_now || "",
        glid: "",
        sglsn: "",
        member_sn: "",
        mem_cate_id: 0,
        particularid: "",
    };
    const { values, errors, touched, setFieldValue, handleBlur, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            try {
                await fetchDataFromApi(AppURL.AccountURL + `account/ledger/data/list/create/view/?from_date_n=${values.from_date_n}&to_date_n=${values.to_date_n}&member_sn=${values.member_sn}&sglsn=${values.sglsn}&particularid=${values.particularid}`).then((res) => {
                    setOnLedgerList(res);
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    const [onSearchMem, setOnSearchMem] = useState("")
    const handleSelect = (item: string) => {
        setOnSearchMem(item);
    };
    const { data: member_data, loading: member_loading, error: member_error } = useFetchSubData(`${AppURL.ApplicationURL}app/all/member/search/report/list/?search=${onSearchMem}`, onSearchMem);
    const searchMemberListOptions = SearchMemberListOptions(member_data?.results);

    const handleSelectBox = (name: string, selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : null;
        setFieldValue(name, value);
    };

    const { data: sub_ledg, loading: sub_loading, error: sub_error, refetch } = useFetchSubData(
        values.glid ? `${AppURL.AccountURL}account/general/ledger/wise/sub/options/view/?glid=${values.glid}` : '',
        values.glid
    );
    const { data: part_data, loading: part_loading, error: part_error, refetch: refetchPart } = useFetchSubData(
        values.glid ? `${AppURL.AccountURL}account/sub/ledger/wise/particular/options/view/?sglsn=${values.sglsn}` : '',
        values.sglsn
    );
    if (loading) {
        return <Typography>Loading...</Typography>;
    }
    if (error) {
        return <Typography color="error">Error: {error}</Typography>;
    }
    const generalLedgerOptions = data ? GeneralLedgerOptions(data?.data) : [];
    const subLedgerOptions = sub_ledg ? SubLedgerOptions(sub_ledg.data.sub_ledger) : [];
    const particularOptions = part_data ? ParticularOptions(part_data.data.particular) : [];
    
    return (
        <Container padding>
            <SecHeading type='add' label='AC/Ledger' />
            <form onSubmit={handleSubmit}>
                <Grid container spacing={0.5}>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                        <InputTextBox
                            type='text'
                            name='from_date_n'
                            label='From Date(B.S.)'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'from_date_n' })}
                            error={typeof errors.from_date_n === 'string' ? errors.from_date_n : undefined}
                            handleBlur={handleBlur}
                            touched={touched.from_date_n}
                            value={values.from_date_n}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                        <InputTextBox
                            type='text'
                            name='to_date_n'
                            label='To Date(B.S.)'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'to_date_n' })}
                            value={values.to_date_n}
                            error={typeof errors.to_date_n === 'string' ? errors.to_date_n : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.to_date_n}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                        <SelectInputBox
                            label='General Ledger'
                            options={generalLedgerOptions}
                            optionSelect={(name, selectedOption) => {
                                setFieldValue('particularid', '');
                                setFieldValue('member_sn', '');
                                handleSelectBox(name, selectedOption);
                            }}
                            isLoading={loading}
                            value={values.glid}
                            required={true}
                            placeholder='Select general ledger'
                            name='glid'
                            handleBlur={handleBlur}
                            touched={touched.glid}
                            errors={errors.glid}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                        <SelectInputBox
                            label='Sub Ledger'
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("mem_cate_id", selectedOption.mem_cate_id);
                                setFieldValue('member_sn', '');
                                handleSelectBox(name, selectedOption);
                            }}
                            name='sglsn'
                            isLoading={sub_loading}
                            options={subLedgerOptions}
                            value={values.sglsn}
                            errors={errors.sglsn}
                            touched={touched.sglsn}
                            required={true}
                            placeholder='Select Sub ledger'
                        />
                    </Grid>
                    {
                        values.mem_cate_id === 1 && <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                            <SelectInputBox
                                label='Member List'
                                options={searchMemberListOptions}
                                optionSelect={(name, selectedOption) => {
                                    handleSelectBox(name, selectedOption);
                                }}
                                isLoading={false}
                                value={values.member_sn}
                                required={true}
                                placeholder='Select Member List'
                                name='member_sn'
                                clear
                                handleBlur={handleBlur}
                                debouncedHandleInputChange={handleSelect}
                                touched={touched.member_sn}
                                errors={errors.member_sn}
                            />
                        </Grid>
                    }
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                        <SelectInputBox
                            label='Particular'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox(name, selectedOption);
                            }}
                            options={particularOptions}
                            value={values.particularid}
                            isLoading={part_loading}
                            required={false}
                            placeholder='Select Particular'
                            name='particularid'
                            errors={errors.particularid}
                            touched={touched.particularid}
                        />
                    </Grid>
                    <Grid item lg={values.mem_cate_id === 1 ? 6 : 9} md={values.mem_cate_id === 1 ? 6 : 9} xs={12} xl={values.mem_cate_id === 1 ? 6 : 9} sm={12}>
                        <EndBaseLine top={18}>
                            <Button el='button' type='submit' btn_type='search' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </Container>

    )
}

export default LedgerFormView